// extracted by mini-css-extract-plugin
export default {"passenger-information__container":"OrderBookedPassengerDetails_passenger-information__container__XxKc9","list-item":"OrderBookedPassengerDetails_list-item__04e+L"};